import Layout from "@/layout";
export default {
    meta: {
        title: "结算",
        icon: "ali_rygl",
    },
    path: "/settle",
    component: Layout,
    children: [
        {
            path: "/settle/statistics",
            name: "settleStatistics",
            component: () => import("@/views/Settle/Statistics/index"),

            meta: {
                title: "对账统计",
                auth: [],
                img: "jsqx",
            },
        },
        // {
        //   path: "/settle/manage",
        //   name: "settleManage",
        //   component: () => import("@/views/Settle/Manage/index"),

        //   meta: {
        //     title: "对账管理",
        //     auth: [],
        //     img: "bm",
        //   },
        // },
        {
            path: "/BxComAdmin/index",
            name: "BxComIndex",
            component: () => import("@/views/BxComAdmin/index"),
            meta: {
                title: "保险公司",
                auth: [],
                img: "bm",
            },
        },
        {
            path: "/settle/insure",
            name: "settleInsure",
            component: () => import("@/views/Settle/Insure/index"),
            meta: {
                title: "非合作共保公司",
                auth: [],
                img: "bm",
            },
        },
        // {
        //     path: "/settle/List",
        //     name: "src/views/Settle/Insure/index.vue",
        //     component: () => import("@/views/Settle/List/index"),
        //     meta: {
        //         title: "保险公司",
        //         auth: [],
        //         img: "bm",
        //     },
        // },
        {
            path: "/settle/List",
            name: "settleList",
            component: () => import("@/views/Settle/List/index"),

            meta: {
                title: "结算单管理",
                auth: [],
                img: "bm",
            },
        },
        {
            path: "/AdminInsureSafe/index",
            name: "AdminInsureSafe",
            component: () => import("@/views/AdminInsureSafe/index"),

            meta: {
                title: "保单管理",
                auth: [],
                img: "bm",
            },
        },
        // {
        //     path: "/settle/unsettled",
        //     name: "settleUnsettled",
        //     component: () => import("@/views/Settle/unsettled/index"),

        //     meta: {
        //         title: "历史尚未结算保单",
        //         auth: [],
        //         img: "bm",
        //     },
        // },
    ],
};
